import { BreakpointsRender, CUSTOM_LAPTOP_WIDTH } from '@components';
import { BlockStepManagerProvider } from '@modules';

import { LoginScreenDesktop } from './login.desktop';
import { useLoginScreenHelper } from './login.helper';
import { LoginScreenMobile } from './login.mobile';

export const RENDER_BLOCK_STEP_LOGIN = 'loginWizard';

export const LoginScreen = () => {
	const props = useLoginScreenHelper();

	return (
		<BlockStepManagerProvider>
			<BreakpointsRender
				mobile={<LoginScreenMobile {...props} />}
				laptop={<LoginScreenDesktop {...props} />}
				customLaptopWidth={CUSTOM_LAPTOP_WIDTH}
			/>
		</BlockStepManagerProvider>
	);
};
